import { datadogRum } from "@datadog/browser-rum";
import "core-js/actual";
import React from "react";
import ReactDOM from "react-dom/client";

import { RouterRoot } from "./routes";

const isProd = import.meta.env.STW_ENV_NAME === "production";

if (import.meta.env.STW_ENV_NAME !== "local") {
  datadogRum.init({
    applicationId: "b9d26fc7-ba07-4403-894a-5b188360630a",
    clientToken: "pub8d9bf744f6dff7407863eef8c26aa51e",
    site: "datadoghq.com",
    service: "stw-t",
    env: import.meta.env.STW_ENV_NAME,
    version: import.meta.env.VITE_BUILD_TIMESTAMP,
    sessionSampleRate: 100, // percentage of all sessions
    sessionReplaySampleRate: isProd ? 50 : 100, // this is a percentage of the sessionSampleRate
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask",
    allowedTracingUrls: [
      /https:\/\/shared\..*\.scaletowin\.io/,
      "https://shared.app-api.scaletowin.com",
    ],
    enableExperimentalFeatures: ["feature_flags"],
  });
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <RouterRoot />
  </React.StrictMode>
);
